// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Available landing page options
 */

export const LandingPageTypeDto = {
    MyProfile: 'MY_PROFILE',
    ProfileSearch: 'PROFILE_SEARCH',
    RequestTracker: 'REQUEST_TRACKER',
} as const;

export type LandingPageTypeDto = typeof LandingPageTypeDto[keyof typeof LandingPageTypeDto];



